import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import { RepairDashboard } from './components/RepairDashboard';
import { RequireSuperAdmin } from './components/RequireSuperAdmin';

function App() {
    return (
        <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
                path="/"
                element={
                    <RequireSuperAdmin>
                        <DashboardPage />
                    </RequireSuperAdmin>
                }
            />
            <Route
                path="/repair"
                element={
                    <RequireSuperAdmin>
                        <RepairDashboard />
                    </RequireSuperAdmin>
                }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}

export default App;
